import * as tslib_1 from "tslib";
export function isFlagEnabled(flags, condition) {
    if (typeof condition === 'string') {
        return !!flags[condition];
    }
    return condition(flags);
}
export function getEnabledFlagList(flags) {
    return Object.keys(flags).filter(function (flag) { return !!flags[flag]; });
}
/**
 * Converts the features array into features object
 */
export function flagsFromSession(features) {
    if (!features) {
        return {};
    }
    return features.reduce(function (o, feature) {
        var _a;
        return (tslib_1.__assign({}, o, (_a = {}, _a[feature] = true, _a)));
    }, {});
}
//# sourceMappingURL=helpers.js.map